import { type JSX } from 'react';
import { useIntl } from 'react-intl';

import { PartnerData } from '../shared/types';
import messages from './messages';
import {
	CalmLogo,
	CalmLogoImageContainer,
	Container,
	ContentWrapper,
	HeroText,
	HeroWrapper,
	ImageContainer,
	LogoDivider,
	LogoWrapper,
	PartnerLogo,
	PartnerName,
	SubHeroText,
} from './styles';

interface Props {
	activeScreen: string;
	partnerDetails: PartnerData;
}

function Hero({ activeScreen, partnerDetails }: Props): JSX.Element {
	const showMessage = activeScreen === 'welcome' || activeScreen === 'error';
	const { formatMessage } = useIntl();
	const { logo_url, name, pageInfo } = partnerDetails;
	const logoBranding = logo_url && logo_url.length > 0 ? logo_url : pageInfo?.logo;

	function getPartnerBranding(): JSX.Element | null {
		if (partnerDetails.id === '') {
			return null;
		}
		if (logoBranding) {
			return (
				<>
					<LogoDivider />
					<ImageContainer>
						<PartnerLogo
							data-testid="partner_logo"
							alt={`The logo for ${partnerDetails.name}`}
							src={logoBranding}
							fill
							style={{ objectFit: 'contain', objectPosition: 'left' }}
						/>
					</ImageContainer>
				</>
			);
		}
		if (name) {
			return (
				<>
					<LogoDivider />
					<PartnerName data-testid="partner_name">{name}</PartnerName>
				</>
			);
		}
		return null;
	}

	if (!partnerDetails) {
		return <div>{formatMessage(messages.loading)}</div>;
	}

	return (
		<Container>
			<HeroWrapper compact={!showMessage} disableGradient={pageInfo.disableGradient}>
				<ContentWrapper>
					<>
						<HeroText>
							{pageInfo.messages.headline &&
								formatMessage(pageInfo.messages.headline, {
									breakingLine: <p />,
								})}
						</HeroText>
						<LogoWrapper>
							<CalmLogoImageContainer>
								<CalmLogo
									alt={'Calm logo'}
									src="/_n/images/calm-logo-square.png"
									fill
									style={{ objectFit: 'contain', objectPosition: 'left' }}
								/>
							</CalmLogoImageContainer>
							{getPartnerBranding()}
						</LogoWrapper>
						{pageInfo.messages?.subheadline && (
							<SubHeroText>{formatMessage(pageInfo.messages?.subheadline)}</SubHeroText>
						)}
					</>
				</ContentWrapper>
			</HeroWrapper>
		</Container>
	);
}

export default Hero;
